const buildLandlordFileDataObject = (applicantId, fileName, base64File) => {
  const dataObject = {
    qdbapi: {
      udata: "EVICTION_DIVERSION_APPLICATION_FILE_UPLOAD",
      field: [
        {
          _fid: "6",
          __text: applicantId,
        },
        {
          _fid: "8",
          _filename: fileName,
          __text: base64File,
        },
      ],
    },
  };

  return dataObject;
};
export default buildLandlordFileDataObject;
